import { useHistory } from "react-router-dom";
import { Container } from "reactstrap";
import styled from "styled-components";
import NewFooter from "../../components/Footers/NewFooter";
import NewNavbar from "../../components/Navbar/NewNavbar";
import { PageContainer, PrimaryButton } from "../../components/styled/shared";
import { FREE_MONTHLY_CREDITS } from "../../constants/credits";

const MainContent = styled.div`
  flex: 1;
  padding: 120px 0 80px;
  display: flex;
  align-items: center;

  @media (max-width: 767.98px) {
    padding: 100px 0 60px;
  }
`;

const PageTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 16px;

  @media (max-width: 767.98px) {
    font-size: 36px;
  }
`;

const PageSubtitle = styled.p`
  font-size: 18px;
  color: #6b7280;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 60px;
  line-height: 1.6;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 767.98px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const OptionCard = styled.div`
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  padding: 40px 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: #6b7280;
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 767.98px) {
    padding: 32px 24px;
  }
`;

const CardIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #e6f4f3;
  color: #0e7e7a;

  svg {
    width: 26px;
    height: 26px;
  }
`;

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.5" y2="16.5" strokeLinecap="round" />
  </svg>
);

const ClipboardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <path d="M9 4a3 3 0 0 1 6 0" />
    <line x1="9" y1="10" x2="15" y2="10" strokeLinecap="round" />
    <line x1="9" y1="14" x2="15" y2="14" strokeLinecap="round" />
    <line x1="9" y1="18" x2="13" y2="18" strokeLinecap="round" />
  </svg>
);

const CardTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
`;

const CardDescription = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #6b7280;
  margin-bottom: 0;
  flex: 1;
`;

const FreeLine = styled.p`
  font-size: 15px;
  color: #6b7280;
  text-align: center;
  margin: -44px auto 48px;
`;

const CardButton = styled(PrimaryButton)`
  padding: 12px 32px;
  font-size: 15px;
  margin-top: 28px;
`;

const GetStartedPage = () => {
  const history = useHistory();

  return (
    <PageContainer>
      <NewNavbar />
      <MainContent>
        <Container>
          <PageTitle>What can we help you with?</PageTitle>
          <PageSubtitle>Choose the option that matches where you are in the process.</PageSubtitle>
          <FreeLine>
            Free to start — every account includes {FREE_MONTHLY_CREDITS.toLocaleString("en-US")}{" "}
            credits a month.
          </FreeLine>

          <CardsContainer>
            <OptionCard onClick={() => history.push("/verify")} data-testid="zillow-card">
              <CardIcon>
                <SearchIcon />
              </CardIcon>
              <CardTitle>Listing Review</CardTitle>
              <CardDescription>
                Already listed on Zillow? Paste your link and we'll analyze your listing with
                actionable recommendations to improve buyer interest.
              </CardDescription>
              <CardButton type="button">Review my listing</CardButton>
            </OptionCard>

            <OptionCard onClick={() => history.push("/submit")} data-testid="manual-card">
              <CardIcon>
                <ClipboardIcon />
              </CardIcon>
              <CardTitle>Pre-Listing Prep</CardTitle>
              <CardDescription>
                Preparing to list? Enter your property details and upload photos to get a listing
                prep that positions your property to stand out from day one.
              </CardDescription>
              <CardButton type="button">Prepare my listing</CardButton>
            </OptionCard>
          </CardsContainer>
        </Container>
      </MainContent>
      <NewFooter />
    </PageContainer>
  );
};

export default GetStartedPage;
